import React, { useEffect, useState } from "react";
import { Modal, DatePicker } from "antd";
import moment from "moment";

/**
 * Modal for setting (or clearing) an asset's expiry_date. `initialExpiry`
 * is an ISO date string ("YYYY-MM-DD") or null. Display is AU
 * DD/MM/YYYY; the wire format stays ISO so the backend stays locale-
 * agnostic.
 *
 * Kept separate from the SDS variant so asset-side copy / validation
 * (e.g. an "ongoing" / "no expiry" radio for warranty-style fields) can
 * evolve independently.
 */
const AssetSetExpiryModal = ({
  visible,
  initialExpiry = null,
  onCancel,
  onConfirm,
  confirmLoading = false,
  assetName = "",
}) => {
  // Antd's DatePicker prefers `undefined` over `null` for the empty
  // state — passing `null` triggers a console warning in newer v4
  // builds. Both render an empty input, but undefined matches the
  // documented prop signature.
  const [date, setDate] = useState(initialExpiry ? moment(initialExpiry) : undefined);

  useEffect(() => {
    if (visible) {
      setDate(initialExpiry ? moment(initialExpiry) : undefined);
    }
  }, [visible, initialExpiry]);

  const handleOk = () => {
    onConfirm(date ? date.format("YYYY-MM-DD") : null);
  };

  return (
    <Modal
      title={assetName ? `Set expiry on "${assetName}"` : "Set expiry date"}
      visible={visible}
      onOk={handleOk}
      onCancel={onCancel}
      okText="Save"
      confirmLoading={confirmLoading}
      destroyOnClose
      zIndex={1200}
      wrapClassName="asset-set-expiry-modal"
    >
      <DatePicker
        style={{ width: "100%" }}
        value={date}
        onChange={(value) => setDate(value)}
        placeholder="Select expiry date"
        format="DD/MM/YYYY"
        getPopupContainer={(trigger) => trigger.parentNode}
      />
      <div style={{ marginTop: 12, fontSize: 12, color: "#888" }}>
        Leave empty to remove the expiry date. Reminders fire 30 days
        before, 7 days before, on the day, and 7 days after — but only
        when the asset also has an assigned user.
      </div>
    </Modal>
  );
};

export default AssetSetExpiryModal;
